module.exports = __webpack_public_path__ + "img/share-square-solid.bcaaa74c.svg";